export const input = {
    base: `flex h-10 w-full rounded-md border border-input bg-background 
        px-3 py-2 text-sm ring-offset-background 
        file:border-0 file:bg-transparent file:text-sm file:font-medium 
        placeholder:text-muted-foreground 
        focus-visible:outline-none focus-visible:ring-2 
        focus-visible:ring-ring focus-visible:ring-offset-2 
        disabled:cursor-not-allowed disabled:opacity-50`,

    variants: {
        default: '',
        search: 'pl-8',  // Space for search icon
        error: 'border-destructive focus-visible:ring-destructive'
    },

    error: "border-destructive focus-visible:ring-destructive",
    disabled: "cursor-not-allowed opacity-50"
} as const
